import {Component, Input} from '@angular/core';
import {Product} from "@app/core/product/domain/dtos/product";

@Component({
  selector: 'ep-product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.scss']
})
export class ProductCarouselComponent {

  @Input() hasAddToListButton = true;

  @Input() isLoading?: boolean | null = false;

  @Input() products: Product[] = [];

}
